module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Out of My Later Years")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#tahir0003",
      "id": "tahir003"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#tahir0003"
    }
  }, [_vm._v("Self-Portrait")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("OF WHAT IS SIGNIFICANT in one’s own existence one is hardly aware, and it certainly should not bother the other fellow. What does a fish know about the water in which he swims all his life?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The bitter and the sweet come from the outside, the hard from within, from one’s own efforts. For the most part I do the thing which my own nature drives me to do. It is embarrassing to earn so much respect and love for it. Arrows of hate have been shot at me too; but they never hit me, because somehow they belonged to another world, with which I have no connection whatsoever.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I live in that solitude which is painful in youth, but delicious in the years of maturity.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04c96ad2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch002.vue
// module id = 75
// module chunks = 0